import React, { forwardRef } from 'react';
import classnames from 'classnames';

import style from './style.module.scss';

const RoundButton = forwardRef(({
  onClick,
  className,
  children,
  title,
  disabled,
}, ref) => (
  <button
    ref={ref}
    title={title}
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={classnames(style.btn, className, 'btn-primary')}
  >
    <span>
      {children}
    </span>
  </button>
));

export default RoundButton;
